module.exports = __webpack_public_path__ + "65084ee43866f3a5c9503e1b2ebf72ad.svg";